import { render } from "./RoomOrderDetail.vue?vue&type=template&id=1a7e8508&scoped=true"
import script from "./RoomOrderDetail.vue?vue&type=script&lang=js"
export * from "./RoomOrderDetail.vue?vue&type=script&lang=js"

import "./RoomOrderDetail.vue?vue&type=style&index=0&id=1a7e8508&scoped=true&lang=css"

import exportComponent from "D:\\京欣医疗用户端\\login_init\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7e8508"]])

export default __exports__